import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { AccessResult, NO_ACCESS_MESSAGE, hasAnyRequiredActionsInAnySpace } from "utils/access";
import { Action } from "types/generated";

export const CREATE_TEMPLATE_DEPLOYMENT_ACCESS_TYPES = [
  Action.SpaceAdmin,
  Action.CreateBlueprintDeployment,
];

/**
 * Hook that returns whether current user can create template deployment
 * User needs to be an admin or have SpaceAdmin or CreateBlueprintDeployment action in at least one space
 * @returns {AccessResult} Object indicating if user can create template deployment and a message if not
 */
const useCanCreateTemplateDeployment = (): AccessResult => {
  const { viewer } = useTypedContext(AccountContext);

  if (viewer.admin) {
    return { result: true };
  }

  const result = hasAnyRequiredActionsInAnySpace(CREATE_TEMPLATE_DEPLOYMENT_ACCESS_TYPES, viewer);

  if (result) {
    return { result: true };
  }

  return { result: false, message: NO_ACCESS_MESSAGE };
};

export default useCanCreateTemplateDeployment;
